export default () => {
    let arr = []

    let current_date = new Date().getTime()

    let counter_day = 0

    for(let i = 0; i < 3; i++) {
        let local_timestamp = counter_day * 60 * 60 * 1000

        let local_date = new Date(current_date + local_timestamp)

        arr.push({
            day: local_date.getDate(),
            month: local_date.getMonth() + 1,
            year: local_date.getFullYear()
        })

        // for next step
        counter_day = counter_day + 24
    }

    return arr
}